const CSS_CONFIG = {
    mainMenuWidth: '223px',
    reqNavWidth: '250px'
}

export default CSS_CONFIG